var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInstall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9266 22.8911L17.7931 23.3051C17.1886 23.5259 16.5181 23.2141 16.2899 22.6062L14.5434 17.9587C12.6297 17.9113 10.9372 16.6943 10.2896 14.8876C9.62769 13.0923 10.1157 11.0788 11.5258 9.78076L12.6219 12.7817C12.8427 13.3862 13.5132 13.6979 14.1251 13.4806L15.2659 13.07C15.8704 12.8492 16.1822 12.1786 15.9648 11.5668L14.8721 8.55847C16.7971 8.62002 18.497 9.84048 19.1628 11.6466C19.8139 13.4459 19.3077 15.4599 17.8898 16.7364L19.6255 21.3879C19.8463 21.9924 19.5345 22.6629 18.9266 22.8911Z",
    fill: "#6D758F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 12.3,
    stroke: "#6D758F",
    strokeWidth: 2.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstall);
export default __webpack_public_path__ + "static/media/icon-install.41e0f77f2a4ff228571c7cf759401602.svg";
export { ForwardRef as ReactComponent };